import React from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioExpediente from '../servicios/ServicioTcExpediente';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { Lightbox } from 'primereact/lightbox';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import ModalSubirExpediente from './ModalSubirExpediente';
export class DetalleDocumentos extends React.Component {
    constructor(props) {
        super(props)
        const { handle } = this.props.match.params;
        const { id } = this.props.location.state;

        this.state = {
            iFrameSrc: null,
            nombreTrabajador:{},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            accion: null,
            tcTrabajador:{},
            mostrarMensaje:false,
            tcIdentificador: {},
           
        }
        const {nombreTrabajador, tcIdentificador,tcTrabajador} = this.state;
        nombreTrabajador.nombre=id.nombre;
        tcIdentificador.id = id.id;
        tcTrabajador.rfc=id.rfc;
    }
    componentDidMount() {
       
        this.obtenerPagina();

    }
    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }

    obtenerPagina() {
        let { paginacion, tcTrabajador ,tcIdentificador} = this.state;
        
        let nombrePropiedad = "alias_tcTrabajador.rfc";
        paginacion.restricciones = {};
        paginacion.restricciones[nombrePropiedad] = tcTrabajador.rfc;
        servicioExpediente.paginacionExAdmin(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

       
    }
    iconoTipoDocumento = (rowData, column) => {
        let tipo = rowData.tipo;
      return <div>
            {tipo == 0 ?
          <Button type="button" icon="pi-md-check" className="p-button-success"
            name="objeto" tooltip="Visible para el Usuario">
          </Button>
          : null}
           {tipo == 1 ?
          <Button type="button" icon="pi-md-highlight-off" className="p-button-danger"
            name="objeto" tooltip="No visible para el Usuario">
          </Button>
          : null}
        </div>
        ;
      }
      columnaVerArchivo = (rowData, column) => {
        return <div>
            <div>
                <Button icon="pi-md-remove-red-eye" type="button" tooltip="Ver archivo" onClick={(e) => this.visorPdf(column.rowData, 'pdf')}></Button>
            </div>
        </div>;

    }
    plantillaOpciones(rowData, column) {
        return <div className="p-grid">



            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-delete" className="p-button-danger" name="desactivar"
                    tooltip="eliminar" onClick={this.accion.bind(this, column.rowData, 'eliminar')} >>
            </Button>
            </div>


        </div>;
    }
    visorPdf = (objeto, tipo) => {
        servicioArchivo.descargaArchivoComoBlob('/expediente/descarga_archivo_pdf.json?id=' + objeto.id + '&tipo=' + tipo)
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });

    }
    accion(objeto, opcion) {
        let { tcExpediente, accion } = this.state;
        tcExpediente = objeto;
        accion = opcion;
        this.setState({ tcExpediente, accion });
        if (accion === 'eliminar')
            this.setState({ mostrarMensaje: true });


    }
    aceptar() {
        let { accion } = this.state;
        this.setState({ mostrarMensaje: false });
        if (accion === 'eliminar')
            this.eliminar();



    }
    eliminar() {
        let { tcExpediente } = this.state;

        servicioExpediente.eliminarExpedienteAdmin(tcExpediente).then((response) => {
            this.resetEstados();
            this.obtenerPagina();
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        }).catch((error) => { });
    }
    resetEstados() {

        this.setState({
            mostrarMensaje: false
        });
    }

    render() {
       const {nombreTrabajador,paginacion,inicio,iFrameSrc,tcIdentificador} = this.state;
       const visorPdfTarget = (
        <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
    );
       const pieMensaje = <div className="ui-dialog-buttonpane p-clearfix">
       <Button label="Aceptar" icon="pi-md-check" onClick={this.aceptar.bind(this)} />
       <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.resetEstados.bind(this)} />
   </div>;
        return (
            <div className="content-section implementation">
                  <Growl ref={(el) => this.growl = el} />
                  <Lightbox target={visorPdfTarget}>
                    <div id="contenedorIframe"  >
                        <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" ></iframe>
                    </div>
                </Lightbox>
                <div className="card card-w-title">
                <h1>Documentos del trabajador : {nombreTrabajador.nombre}</h1>
                <ModalSubirExpediente  tcIdentificador={tcIdentificador}></ModalSubirExpediente>
                <div className="p-grid">
                <div className="p-col-10">
                    </div>
                <div className="p-col-2">
                            <Button className="p-button-Primary p-button-raised" label={<Link className="colorRegresar" to={{
                                pathname: "/consultareciboquadrum/bienvenido/expediente",
                                state: {}
                            }}>Regresar</Link>}>

                            </Button>
                            </div>
                        </div>
                </div>
                <div className="content-section implementation">
                        <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} resizableColumns={true} responsive={true}>
                            <Column field="nombre" header="Nombre del archivo" />
                            <Column field="tipo" body={this.iconoTipoDocumento} header="Visibilidad para el usuario" />
                            <Column field="nombreDocumento"  header="Documento" />
                            <Column header="Ver Archivo" body={this.columnaVerArchivo} autoLayout={true} />
                            <Column header="Opciones" body={this.plantillaOpciones.bind(this)} />
                        </DataTable>
                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                    </div>
                    <Dialog visible={this.state.mostrarMensaje} style={{ width: '30%' }} modal={true} header="Confirmación" footer={pieMensaje} onHide={this.resetEstados.bind(this)}>
                            <center><h4>¿Estas seguro?</h4></center>
                        </Dialog>
            </div>
        )
    }
}
export default DetalleDocumentos;